import { ComponentTokens, getComponentToken } from '@optimus-web/common';
import { LinearProgressVariants, LinearValueBarProps } from './types';

const getLinearProgressState = (props: Pick<LinearValueBarProps, 'disabled' | 'variant'>) => {
    const { variant, disabled } = props;

    return {
        state: disabled ? 'disabled' : 'default',
        variant: variant || 'default',
    };
};

const linearProgressTokens = {
    backgroundColor: {
        default: {
            primary: {
                disabled: 'textDisabled',
                default: 'legacyTagTextPrimary',
            },
            success: {
                disabled: 'textDisabled',
                default: 'textAlertSuccess',
            },
            error: {
                disabled: 'textDisabled',
                default: 'textAlertDanger',
            },
            warning: {
                disabled: 'textDisabled',
                default: 'backgroundAlertWarningPrimary',
            },
            default: {
                disabled: 'textDisabled',
                default: 'legacyTagTextBasicBold',
            },
        },
    },
} satisfies ComponentTokens<LinearProgressVariants | 'default', 'disabled' | 'default'>;

export const getLinearProgessToken = getComponentToken(linearProgressTokens, getLinearProgressState);
